import React from "react";

const ChartLoader = () => (
    <div className="bg-white rounded-xl shadow-sm">
      <div className="p-6">
        <div className="animate-pulse">
          <div className="h-6 w-32 bg-gray-200 rounded mb-2"></div>
          <div className="h-4 w-48 bg-gray-100 rounded mb-4"></div>
          <div className="h-80 bg-gray-100 rounded"></div>
        </div>
      </div>
    </div>
);

export default ChartLoader;